export default "__VITE_ASSET__CyZ7PK10__"